<form [formGroup]="formGroup" (ngSubmit)="save()">
  <div class="modal-header">
    <div class="modal-title h5" id="modalTitle">
      {{ viewMode === ViewMode.Create ? "Create permission mapping" : viewMode === ViewMode.View ? "View permission mapping" : "Edit permission mapping" }}
    </div>
    <button type="button" class="close" (click)="activeModal.close()" aria-label="Close"><span aria-hidden="true">&times;</span></button>
  </div>

  <div class="modal-body">
    @if (errorMessage) {
    <alert type="danger" [dismissible]="true" (onClose)="errorMessage = undefined">
      <coso-alert-message>
        <div class="d-inline" [innerHTML]="errorMessage"></div>
      </coso-alert-message>
    </alert>
    }
    <p class="text-muted">
      <small><em>All fields are required unless specified optional</em></small>
    </p>
    <coso-select-input type="text" [control]="formGroup.controls.accessRight" [inputText]="formText.accessRight" [readonly]="viewMode === ViewMode.View"></coso-select-input>
    @if (groupStorage === GroupStorage.SharePoint) {
    <coso-select-input type="text" [control]="formGroup.controls.permissionLevel" [inputText]="formText.permissionLevel" [readonly]="viewMode === ViewMode.View"></coso-select-input>
    } @if (groupStorage !== GroupStorage.SharePoint) {
    <coso-text-input type="text" [control]="formGroup.controls.permissionLevelName" [inputText]="formText.permissionLevelName" [readonly]="viewMode === ViewMode.View"></coso-text-input>
    <div class="form-group row">
      <label id="permissionsLabel" class="col-lg-4 col-md-12 col-form-label text-lg-right">
        SharePoint Permissions to be Assigned
        <span class="form-label-anchor">(optional)</span>
      </label>
      <div class="col-lg-6 col-md-12" aria-labelledby="permissionsLabel" role="listbox">
        <div class="permissions-list grid-2x">
          <div class="custom-control custom-checkbox grid-item">
            <input
              type="checkbox"
              class="custom-control-input"
              id="permissionCheckbox_all"
              name="'permissionCheckbox_all"
              [value]="areAllPermissionsSelected"
              [checked]="areAllPermissionsSelected"
              (change)="selectAll()"
              [disabled]="viewMode === ViewMode.View"
            />
            <label class="custom-control-label" for="permissionCheckbox_all">Select all</label>
          </div>
          @for (permission of allPermissions; track permission; let i = $index) {
          <div class="custom-control custom-checkbox grid-item">
            <input
              role="option"
              type="checkbox"
              class="custom-control-input"
              [value]="permission"
              [id]="'permissionCheckbox' + i"
              [name]="'permissionCheckbox' + i"
              aria-required="false"
              aria-invalid="false"
              [checked]="formGroup.value.permissions.includes(permission)"
              [attr.aria-checked]="formGroup.value.permissions.includes(permission)"
              (change)="inputChecked($event)"
              [disabled]="viewMode === ViewMode.View"
            />
            <label class="custom-control-label" [for]="'permissionCheckbox' + i">{{ getPermissionKindName(permission) }}</label>
          </div>
          }
        </div>
      </div>
    </div>
    }

    <coso-select-input type="text" [control]="formGroup.controls.entityName" [inputText]="formText.entityName" [readonly]="viewMode === ViewMode.View"></coso-select-input>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="activeModal.close()">Cancel</button>
    <button type="submit" class="btn btn-primary">Save</button>
  </div>
</form>

<ng-template #permissionLevelPopover>
  <p>An existing permission level or the name of a permission level to be applied to document libraries in SharePoint.</p>
  <p class="text-primary">NONE means that no access is given to a user or group.</p>
  <p class="text-primary">You cannot assign <strong>Limited Access</strong> permissions directly to a user or group.</p>
</ng-template>

<ng-template #permissionLevelNamePopover>
  <p>The name of a permission level to be applied to document libraries in SharePoint. If it does exist, it will be used. Otherwise, one will be created.</p>
  <p class="text-primary">Once created, you will need to remove manually if you choose to.</p>
</ng-template>

<ng-template #entityPopover>
  <p>The logical name of a Dynamics 365 entity.</p>
  <p class="text-primary">NONE means that all entities are considered.</p>
</ng-template>
